// extracted by mini-css-extract-plugin
export var icon = "_67-1";
export var subtext = "_67-0";